import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';

import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { ModulePermissionProps } from 'src/app/common/module/types';
import { ACTIVITY_TRACKING_BASE_PATH, QR_CODE_ACTIVITY_CATEGORY_PATH } from '../../constans';

import QRCodeActivityCategoryListPage from './List';
import QRCodeActivityCategoryDetailPage from './Detail/QRCodeActivityCategoryDetailPage';

const basePath = `${ACTIVITY_TRACKING_BASE_PATH}${QR_CODE_ACTIVITY_CATEGORY_PATH}`;

export const qrCodeActivityCategoryFilterKeys = [
  'name',
  'accessibility',
  'framework',
  'createdAtFrom',
  'createdAtTo',
  'status',
];

const QRCodeActivityCategoryPage: FC<RouteComponentProps & ModulePermissionProps> = ({
  enableRead,
  enableCreate,
  enableUpdate,
}) => {
  return (
    <Switch>
      <Redirect exact from={basePath} to={`${basePath}/list`} />

      <PruRoute
        exact
        path={`${basePath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={qrCodeActivityCategoryFilterKeys}>
            <QRCodeActivityCategoryListPage
              enableRead={enableRead}
              enableCreate={enableCreate}
              enableUpdate={enableUpdate}
            />
          </ParamsProvider>
        )}
      />

      <PruRoute
        exact
        path={`${basePath}/create`}
        render={(props) => (
          <QRCodeActivityCategoryDetailPage
            {...props}
            mode="create"
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />

      <PruRoute
        exact
        path={`${basePath}/edit/:id`}
        render={(props) => (
          <QRCodeActivityCategoryDetailPage
            {...props}
            mode="edit"
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />

      <PruRoute
        exact
        path={`${basePath}/view/:id`}
        render={(props) => (
          <QRCodeActivityCategoryDetailPage
            {...props}
            mode="view"
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />
    </Switch>
  );
};

export default QRCodeActivityCategoryPage;
